/*
 * @Author: zhangsheng
 * @Date: 2023-08-21 09:55:48
 * @LastEditors: duyuanyuan
 * @LastEditTime: 2023-09-28 11:21:16
 * @FilePath: \panda-index-sicermem-frontend\src\pc\router\index.tsx
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import { lazy } from 'react';
import lazyLoad from '@c/components/lozyLoad';
import { MenuRoute } from '@c/types/router';
import pageRouter from './pageRouter';
const Layout = lazyLoad(lazy(() => import(`@p/components/layout/index`)));
const NoMatch = lazyLoad(lazy(() => import(`@p/components/404`)));

const pcRouter: MenuRoute[] = [
  {
    path: 'en',
    name: 'layout',
    key: 'layout',
    element: Layout,
    isSubMenu: false,
    children: [...pageRouter],
  },
  {
    path: '',
    name: 'layout',
    key: 'layout',
    element: Layout,
    isSubMenu: false,
    children: [...pageRouter],
  },
];
export default pcRouter;
